var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"odr-pic",style:(("width: " + _vm.width + " !important; max-width: " + _vm.maxWidth + " !important; min-width: " + _vm.minWidth + " !important"))})}
var staticRenderFns = []

export { render, staticRenderFns }